import {
  SET_CLAIM_TO_PREOPEN,
  RESET_PREOPEN_CLAIM,
  REQUEST_UPDATE_CLAIM,
  SET_CLAIM_ID,
  REQUEST_UPDATE_FRAUD_INFO,
  FIND_PROVISIONAL_CLAIM_BY_REFERENCE,
  SET_IS_PROVISIONAL_CLAIM_EXIST,
} from 'containers/PreOpeningPage/constants';
import { ClaimRecapType } from 'typings/claimTypes';

export const setClaim = (claim: any) => ({
  type: SET_CLAIM_TO_PREOPEN,
  claim,
});

export const resetPreopenClaim = () => ({
  type: RESET_PREOPEN_CLAIM,
});

export const requestUpdateClaim = (
  claimRecap: ClaimRecapType,
  claimId: number,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_CLAIM,
  claimRecap,
  claimId,
  successCallback,
});

export const setClaimId = (claim: any) => ({
  type: SET_CLAIM_ID,
  claim,
});
export const requestUpdateFraudInfo = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_FRAUD_INFO,
  payload,
  successCallback,
});

export const findProvisionalClaimByReference = (
  reference: string,
  successCallback: Function,
) => ({
  type: FIND_PROVISIONAL_CLAIM_BY_REFERENCE,
  reference,
  successCallback,
});

export const setIsProvisionalClaimExist = (isProvisionalClaimExist: any) => ({
  type: SET_IS_PROVISIONAL_CLAIM_EXIST,
  isProvisionalClaimExist,
});
